export function mapCognitoError(
  e,
  flow /* 'login' | 'signup' | 'confirm' | 'forgot' | 'change-password' | 'update-profile' | 'enable-mfa' | 'disable-mfa' */
) {
  const code = e?.code || e?.name || "";
  const msg = (e?.message || e?.toString?.() || "").toLowerCase();

  // Common special cases
  if (code === "UserNotFoundException" || msg.includes("user does not exist")) {
    if (flow === "login")
      return "No account found for that email. Please sign up first.";
    if (flow === "forgot") return "No account found for that email.";
    return "No account found for that email.";
  }

  if (
    code === "NotAuthorizedException" ||
    msg.includes("incorrect username or password")
  ) {
    if (flow === "change-password") return "Incorrect current password.";
    return "Incorrect username or password.";
  }

  if (
    code === "UserNotConfirmedException" ||
    msg.includes("user is not confirmed")
  ) {
    if (flow === "login") {
      return "Email not verified yet. Please confirm your email (or resend the code).";
    }
    return "Email not verified yet.";
  }

  if (code === "UsernameExistsException" || msg.includes("already exists")) {
    if (flow === "signup")
      return "An account already exists with this email. Try logging in.";
    return "An account already exists with this email.";
  }

  if (
    code === "CodeMismatchException" ||
    msg.includes("invalid verification code")
  ) {
    return "The verification code is incorrect. Please try again.";
  }

  if (code === "ExpiredCodeException" || msg.includes("expired code")) {
    return "That verification code has expired. Please request a new one.";
  }

  if (code === "LimitExceededException") {
    return "Too many attempts. Please wait a bit and try again.";
  }

  if (code === "InvalidPasswordException") {
    return "Password does not meet complexity requirements.";
  }

  if (code === "InvalidParameterException") {
    if (flow === "enable-mfa" || flow === "disable-mfa")
      return "Invalid MFA request. Please try again.";
    if (msg.includes("password") || flow === "change-password")
      return "Password does not meet complexity requirements.";
    return "Invalid input provided.";
  }

  if (code === "ResourceNotFoundException") {
    return "Requested resource was not found. Please try again later.";
  }

  if (code === "TooManyFailedAttemptsException") {
    return "Too many failed attempts. Account is temporarily locked.";
  }

  if (code === "SessionExpiredException" || msg.includes("session expired")) {
    return "Your session has expired. Please sign in again.";
  }

  if (msg.includes("access denied") || msg.includes("unauthorized")) {
    return "You are not authorized to perform this action.";
  }

  if (msg.includes("network error") || msg.includes("fetch failed")) {
    return "Network error. Please check your internet connection.";
  }

  // MFA specific
  if (flow === "enable-mfa") {
    if (msg.includes("associate")) {
      return "Failed to start MFA setup. Please try again.";
    }
    if (msg.includes("verify")) {
      return "Invalid MFA code. Please try again.";
    }
    return "Unable to enable MFA. Please try again later.";
  }

  if (flow === "disable-mfa") {
    return "Unable to disable MFA. Please try again later.";
  }

  // fallback
  return e?.message || "Something went wrong. Please try again.";
}
